import type { AparenciaDoCatalogo } from "@bookdental/schemas";
import { ContatosDoCatalogo, temContatos } from "./ContatosDoCatalogo";

/** Rodapé de toda folha do PDF: fixo, o Chrome repete em cada página; fica no recuo de baixo que a
 *  lista deixa em toda folha. A capa (z-10) cobre ele na primeira. */
export function RodapeDaFolha({ nome, aparencia }: { nome: string; aparencia: AparenciaDoCatalogo }) {
  return (
    <div aria-hidden className="hidden text-[7.5pt] text-zinc-500 print:fixed print:inset-x-0 print:bottom-0 print:z-0 print:flex print:h-[16mm] print:items-center print:justify-between print:gap-4 print:px-[14mm]">
      <ContatosDoCatalogo nome={nome} contatos={aparencia.contatos} />
      <span className="shrink-0">Gerado pelo DentalBook</span>
    </div>
  );
}

export function RodapeDoCatalogo({ aparencia, comPreco }: { aparencia: AparenciaDoCatalogo; comPreco: boolean }) {
  return (
    // No PDF este fechamento não sai: contatos e "Gerado pelo DentalBook" vão no RodapeDaFolha e as
    // notas, no começo da lista — no fim, sobravam sozinhas numa folha nova.
    <footer className="mt-8 space-y-1 border-t border-zinc-200 pt-3 print:hidden">
      {temContatos(aparencia.contatos) && <ContatosDoCatalogo contatos={aparencia.contatos} className="text-xs font-medium text-zinc-700" />}
      {aparencia.rodapeTexto && <p className="whitespace-pre-line text-xs text-zinc-600">{aparencia.rodapeTexto}</p>}
      <p className="text-[11px] text-zinc-400">
        {comPreco ? "Preços da tabela base do laboratório; podem variar por cliente. " : ""}
        Gerado pelo DentalBook.
      </p>
    </footer>
  );
}
